import styled from 'styled-components';
interface MoreButtonProps {
  showAll: boolean;
  setShowAll: (value: boolean) => void;
}
const MoreButton = ({ showAll, setShowAll }: MoreButtonProps) => {
  return (
    <Container
      onClick={() => {
        setShowAll(!showAll);
      }}
    >
      <div>{!showAll ? '더보기' : '접기'}</div>
      <img
        style={{
          transform: showAll ? 'rotate(180deg)' : 'rotate(0deg)',
        }}
        src="/assets/images/arrow/Arrow_down.png"
        alt=""
      />
    </Container>
  );
};

export default MoreButton;

const Container = styled.div`
  width: 100%;
  color: black;
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 400;
  line-height: 18.85px;
  word-wrap: break-word;
  border: 1px #e1e2e4 solid;
  border-radius: 4px;
  padding: 12px 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;
